export const TOGGLE_MODAL_RESET = 'TOGGLE_MODAL_RESET';

export function toggleModalReset(queryParams) {
  return {
    type: TOGGLE_MODAL_RESET,
    queryParams,
  };
}
